/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'aisztheme/sass/animate.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  injectIntl,
  FormattedMessage,
} from 'react-intl';
import {
  Col,
  Collapse,
  Grid,
  Nav,
  NavItem,
  Panel,
  Row,
  Tab,
  Table,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import RichForm from 'loracoms/RichForm';
import RichLabel from 'loracoms/RichLabel';
import Refresher from 'loracoms/Refresher';
import PageSizer from 'loracoms/PageSizer';
import Nvl from 'loracoms/Nvl';
import CollapseToggle from 'loracoms/CollapseToggle';
import {
  hexNumValidator,
  intValidator,
  binNumValidator,
  orValidator,
  notEmptyValidator,
} from 'lorautils/Validators';
import {
  writeRegister,
  readRegister,
  getRegisterLogs,
} from 'loraapi/lora_device';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import RingSwitcher from './coms/RingSwitcher';

const kRegisterOpts = _.map(_.range(1, 255), i => ({ value: `r${i}`, label: `r${i}` }));
const propTypes = {
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  deviceState: React.PropTypes.object.isRequired,
  appState: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

class LRAPView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      showHelpDoc: false,
      status: 'idle',
    };
    this.handleWriteSubmit = this.handleWriteSubmit.bind(this);
    this.handleReadSubmit = this.handleReadSubmit.bind(this);
    this.loadLogs = this.loadLogs.bind(this);
    this.handleReloadLogs = this.handleReloadLogs.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.lrapview');
  }

  componentDidMount() {
    this.loadLogs();
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, appState } = nextProps;
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  loadLogs(args = {}) {
    const nargs = {
      pageSize: this.state.pageSize,
      ...args,
    };
    const { cb, pageSize = 20 } = nargs;
    const { deviceId } = this.props;
    this.setState({ status: 'loading' });
    getRegisterLogs(deviceId, { limit: pageSize }).then((resp) => {
      this.setState({
        logs: resp.body.list,
        status: 'success',
      });
      if (cb) {
        cb();
      }
    }).catch(() => {
      if (cb) {
        cb();
      }
      this.setState({
        status: 'failure',
      });
    });
  }

  handleReloadLogs() {
    this.setState({
      logsReloading: true,
    });
    this.loadLogs({
      cb: () => {
        this.setState({
          logsReloading: false,
        });
      },
    });
  }

  handleWriteSubmit(data) {
    const { deviceId } = this.props;
    const { valueFormat } = this.state;
    const { port, register, value } = data;
    if (this.writeStatusTimeout) {
      clearTimeout(this.writeStatusTimeout);
    }

    let numv;
    if (valueFormat === 'HEX') {
      numv = parseInt(value.substr(2), 16);
    } else if (valueFormat === 'BIN') {
      numv = parseInt(value.substr(2), 2);
    } else {
      numv = parseInt(value, 10);
    }

    writeRegister(deviceId, Number(port), register, numv).then(() => {
      this.setState({ writeStatus: 'success' });
      this.writeStatusTimeout = setTimeout(() => {
        this.setState({ writeStatus: '' });
      }, 3000);
    }).catch(() => {
      this.setState({ writeStatus: 'error' });
      this.writeStatusTimeout = setTimeout(() => {
        this.setState({ writeStatus: '' });
      }, 3000);
    });
  }

  handleReadSubmit(data) {
    const { deviceId } = this.props;
    const { port, register } = data;
    if (this.readStatusTimeout) {
      clearTimeout(this.readStatusTimeout);
    }
    readRegister(deviceId, Number(port), register).then(() => {
      this.setState({ readStatus: 'success' });
      this.readStatusTimeout = setTimeout(() => {
        this.setState({ readStatus: '' });
      }, 3000);
    }).catch(() => {
      this.setState({ readStatus: 'error' });
      setTimeout(() => {
        this.setState({ readStatus: '' });
      }, 3000);
    });
  }

  handleChangePageSize(pageSize) {
    this.setState({ pageSize });
    this.loadLogs({ pageSize });
  }

  handleChangeValue(v) {
    if (_.startsWith(v, '0x')) {
      this.setState({ valueFormat: 'HEX' });
    } else if (_.startsWith(v, '0b')) {
      this.setState({ valueFormat: 'BIN' });
    } else {
      this.setState({ valueFormat: null });
    }
  }

  renderToolbar() {
    const { appId, deviceId } = this.props;
    const {
      deviceState: {
        data: { name } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;

    const breadcrumb = [{
      content: (
        <span>
          <FormattedMessage id="application.breadcrumb.application" />
        </span>
      ),
      onClick: () => this.props.pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => this.props.replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderWriteTab() {
    const fields = [{
      id: 'port',
      label: this.intlMsg.msg('port'),
      value: '223',
      placeholder: this.intlMsg.msg('port.placeholder'),
      validator: intValidator(1, 223),
    }, {
      id: 'register',
      type: 'search-selector',
      options: kRegisterOpts,
      label: this.intlMsg.msg('register'),
      placeholder: this.intlMsg.msg('register.placeholder'),
      validator: notEmptyValidator(),
    }, {
      id: 'value',
      label: this.intlMsg.msg('value'),
      placeholder: this.intlMsg.msg('value.placeholder'),
      validator: orValidator([
        intValidator(0, 4294967295),
        hexNumValidator(0, 4294967295),
        binNumValidator(0, 4294967295),
      ]),
      inputLabel: this.state.valueFormat,
      onChange: this.handleChangeValue,
    }];
    const { writeStatus } = this.state;

    return (
      <div className={styles.tab}>
        <RichForm
          fields={fields}
          labelCols={3}
          controlCols={9}
          buttonLabel={this.intlMsg.msg('writesubmit.btn')}
          successButtonLabel={this.intlMsg.msg('writesubmit.btn.success')}
          errorButtonLabel={this.intlMsg.msg('writesubmit.btn.error')}
          onSubmit={this.handleWriteSubmit}
          submitStatus={writeStatus}
        />
        <Row>
          <Col mdOffset={3} md={9}>
            <Collapse in={writeStatus === 'success'}>
              <div>
                <div className={styles.submitTips}>
                  {this.intlMsg.msg('writesubmit.tips')}
                </div>
              </div>
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }

  renderReadTab() {
    const fields = [{
      id: 'port',
      label: this.intlMsg.msg('port'),
      value: '223',
      placeholder: this.intlMsg.msg('port.placeholder'),
      validator: intValidator(1, 223),
    }, {
      id: 'register',
      type: 'search-selector',
      options: kRegisterOpts,
      label: this.intlMsg.msg('register'),
      placeholder: this.intlMsg.msg('register.placeholder'),
      validator: notEmptyValidator(),
    }];
    const { readStatus } = this.state;

    return (
      <div className={styles.tab}>
        <RichForm
          fields={fields}
          labelCols={3}
          controlCols={9}
          buttonLabel={this.intlMsg.msg('readsubmit.btn')}
          successButtonLabel={this.intlMsg.msg('readsubmit.btn.success')}
          errorButtonLabel={this.intlMsg.msg('readsubmit.btn.error')}
          onSubmit={this.handleReadSubmit}
          submitStatus={readStatus}
        />
        <Row>
          <Col mdOffset={3} md={9}>
            <Collapse in={readStatus === 'success'}>
              <div>
                <div className={styles.submitTips}>
                  {this.intlMsg.msg('readsubmit.tips')}
                </div>
              </div>
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }

  renderLogs() {
    const {
      logs = [],
      pageSize = 20,
      displayFormat = 'DEC',
    } = this.state;

    const trs = _.flatMap(logs, (l, i) => {
      const log = { ...l };
      if (log.op === 'read') {
        log.registers = log.registers.map(r => ({
          key: r,
          val: '',
        }));
      } else {
        log.registers = _.map(log.registers, (v, k) => ({
          key: k,
          val: v,
        }));
      }
      const len = log.registers.length;

      let dir;
      if (log.op === 'read' || log.op === 'write') {
        dir = 'down';
      } else {
        dir = 'up';
      }

      return _.map(_.range(0, len), (j) => {
        let numv = Number(log.registers[j].val);
        if (displayFormat === 'HEX') {
          numv = numv === 0 ? '--' : `0x${numv.toString(16)}`;
        } else if (displayFormat === 'BIN') {
          numv = numv === 0 ? '--' : `0b${numv.toString(2)}`;
        } else if (numv === 0) {
          numv = '--';
        }
        if (j === 0) {
          return (
            <tr key={`${i}-${j}`}>
              <td rowSpan={len} className={`${styles[dir]} ${styles.dir}`}>
                <span className={`halflings halflings-direction-${dir}`} />
              </td>
              <td rowSpan={len}>
                <RichLabel
                  content={log.op}
                  enums={[{
                    content: 'read',
                    theme: 'blue',
                  }, {
                    content: 'write',
                    theme: 'green',
                  }, {
                    content: 'trap',
                    theme: 'blue',
                  }, {
                    content: 'except',
                    theme: 'red',
                  }]}
                />
              </td>
              <td rowSpan={len}>{moment(log.$time).format('YYYY-MM-DD HH:mm:ss')}</td>
              <td>{log.registers[j].key}</td>
              <td>{numv}</td>
            </tr>
          );
        }
        return (
          <tr key={`${i}-${j}`}>
            <td>{log.registers[j].key}</td>
            <td>{numv}</td>
          </tr>
        );
      });
    });

    return (
      <div>
        <div className={styles.logTable}>
          <Table className="aisz-table-light" bordered striped hover responsive>
            <thead>
              <tr>
                <th style={{ width: '30px' }} />
                <th>{this.intlMsg.msg('op')}</th>
                <th>{this.intlMsg.msg('optime')}</th>
                <th>{this.intlMsg.msg('register')}</th>
                <th>
                  {this.intlMsg.msg('payload')}{' '}
                  <span className={styles.formatSwitcher}>
                    <RingSwitcher
                      options={[
                        { label: 'DEC', value: 'DEC' },
                        { label: 'HEX', value: 'HEX' },
                        { label: 'BIN', value: 'BIN' },
                      ]}
                      onChange={fmt => this.setState({ displayFormat: fmt })}
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              { trs }
            </tbody>
          </Table>
        </div>
        <div className="pull-right">
          <PageSizer
            pageSize={pageSize}
            options={[20, 50, 100]}
            onChange={this.handleChangePageSize}
          />
        </div>
      </div>
    );
  }

  render() {
    const { logsReloading, logExpanded = true } = this.state;
    const logHeader = (
      <div>
        {this.intlMsg.msg('logs.tableheader')}
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReloadLogs}
              reloading={logsReloading}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={logExpanded}
              onChange={(v) => { this.setState({ logExpanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
          <Col md={12}>
            <div className={styles.tabs}>
              <Tab.Container id="registertabs" defaultActiveKey="write">
                <Row className="clearfix">
                  <Col md={12}>
                    <Nav bsStyle="aisz-tabs">
                      <NavItem eventKey="write">
                        {this.intlMsg.msg('tabs.write.title')}
                      </NavItem>
                      <NavItem eventKey="read">
                        {this.intlMsg.msg('tabs.read.title')}
                      </NavItem>
                    </Nav>
                    <Tab.Content className="aisz-tab-content-white" animation>
                      <Tab.Pane eventKey="write">
                        <div>
                          { this.renderWriteTab() }
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="read">
                        <div>
                          { this.renderReadTab() }
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </Col>
          <Col md={12}>
            <Panel
              bsStyle="aisz-white"
              header={logHeader}
              collapsible
              expanded={logExpanded}
            >
              {this.renderLogs()}
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

LRAPView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.appId,
  deviceId: ownProps.params.deviceId,
  deviceState: state.device.getDevice,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LRAPView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/LRAPView/index.jsx